import { isDACHRegion } from './is-dach-region';
import { isGbpRegion } from './is-gbp-region';
import { isUsdRegion } from './is-usd-region';

export const isCurrencyLocked = (countryCode: string) =>
  isUsdRegion(countryCode) || isGbpRegion(countryCode) || isDACHRegion(countryCode);
